<template>
  <div>
    <v-layout wrap fill-height>
      <v-flex xs2  align-self-start>
        <v-radio-group dense v-model="defaultAddress._id">
          <v-radio
            @click="setDefault"
            color="#48B179"
            :ripple="false"
            :value="storage._id"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs10 >
        <v-layout wrap>
          <v-flex text-left xs12>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 16px;
                color: #000000;
              "
            >
              {{ storage.firstname }} {{ storage.lastname }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex text-left xs12>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              {{ storage.streetAddress }},<br />
              {{ storage.locality }}, {{ storage.city }},<br />
              {{ storage.district }}, {{ storage.state }},<br />
              {{ storage.pincode }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          justify-start
          pt-2
          style="font-family: kumbhsansregular; font-size: 14px"
        >
          <v-flex xs12 text-uppercase text-left>
            <span style="color: #8e8e8e"> Mobile Number </span>
          </v-flex>
          <v-flex xs12 text-left>
            <span style="color: #000000">
              <span v-if="storage.phone"> +91 {{ storage.phone }} </span>
              <span v-else>-</span>
            </span>
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          justify-start
          pt-2
          style="font-family: kumbhsansregular; font-size: 14px"
        >
          <v-flex xs12 text-uppercase text-left>
            <span style="color: #8e8e8e"> Email </span>
          </v-flex>
          <v-flex xs12 text-left>
            <span style="color: #000000">
              <span v-if="storage.phone"> {{ storage.email }} </span>
              <span v-else>-</span>
            </span>
          </v-flex>
        </v-layout>
        <!-- <v-layout pt-3 wrap>
          <v-flex text-left xs12 lg12>
            <v-btn
              depressed
              tile
              small
              outlined
              color="#0000001f"
              style="text-transform: none; background-color: #f9f9f9"
              @click="editAddress"
            >
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #000000;
                "
                >Edit
              </span></v-btn
            >
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage", "defaultAddress"],
  data() {
    return {};
  },
  methods: {
    setDefault() {
      if (this.storage != this.defaultAddress) {
        this.$emit("stepper", {
          ref: "DefaultAddressItem",
          address: this.storage,
        });
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
.radio-container {
  max-height: 0px !important;
}
</style>